'use strict';

// eslint-disable-next-line no-multi-assign
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/appointmentButtonPosition'));

    if ('initialized' in window && window.initialized) {
        return;
    }

    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('schaffrath/components/recaptchaBadgeOverlap'));
    processInclude(require('base/components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/search'));
    processInclude(require('schaffrath/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/orderByEmail'));
    processInclude(require('schaffrath/carousel'));
    processInclude(require('wishlists/product/wishlistHeart'));
    processInclude(require('schaffrath/components/pageDesignerPopup'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
